exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropzone-custom-content{text-align:center}.dropzone-custom-title{margin-top:0;color:#1078d5}.subtitle{color:#314b5f}.fileContainer{margin:0 0 10px}.fileContainer [type=file]{cursor:inherit;display:block;filter:alpha(opacity=0);min-height:100%;min-width:100%;opacity:0;position:absolute;right:0;text-align:right;top:0}.font-select{width:150px}.ve-select span{font-size:14px}.ve-select{min-width:75px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ba96354","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/videos/create.vue
// module id = LT96
// module chunks = 0